import { render } from "./FloatingPanel.vue?vue&type=template&id=6f3eeb4f"
import script from "./FloatingPanel.vue?vue&type=script&lang=js"
export * from "./FloatingPanel.vue?vue&type=script&lang=js"

import "./FloatingPanel.vue?vue&type=style&index=0&id=6f3eeb4f&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__